// extracted by mini-css-extract-plugin
export default {"info":"ShareAction_info__CSqTX"};